import { getNetwork } from "./lib/hooks/useNetwork";
const ROUTES = {
  deployer: "/",
  jetton: "/jetton",
  jettonId: "/jetton/:id",
  management: "/management",
};

const BANAN_TOOL = "UQA66v8k5zlhDGake5GzPlhOdyp7u9t0ZbwnSlQ2JDW9QOvZ";
const CREATE_TOKEN_FEE = "10000000000";

const APP_GRID = 1156;

const LOCAL_STORAGE_PROVIDER = "wallet_provider";

const APP_DISPLAY_NAME = "PinkPump";

const JETTON_DEPLOYER_CONTRACTS_GITHUB = "https://t.me/XPinkPump";

const EXAMPLE_ADDRESS =
  getNetwork(new URLSearchParams(window.location.search)) === "testnet"
    ? "EQBP4L9h4272Z0j_w9PE2tjHhi8OwkrRbTmatKszMyseis05"
    : "EQD-LkpmPTHhPW68cNfc7B83NcfE9JyGegXzAT8LetpQSRSm";

const SEARCH_HISTORY = "searchHistory";

export {
  ROUTES,
  LOCAL_STORAGE_PROVIDER,
  APP_GRID,
  JETTON_DEPLOYER_CONTRACTS_GITHUB,
  APP_DISPLAY_NAME,
  EXAMPLE_ADDRESS,
  SEARCH_HISTORY,
  BANAN_TOOL,
  CREATE_TOKEN_FEE,
};
